import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = c((o, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...o,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M8 0C3.59 0 0 3.59 0 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m0 14.5c-3.58 0-6.5-2.92-6.5-6.5S4.42 1.5 8 1.5s6.5 2.92 6.5 6.5-2.92 6.5-6.5 6.5"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M11.7 7.25H8.75V4.3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.95H4.3c-.41 0-.75.34-.75.75s.34.75.75.75h2.95v2.95c0 .41.34.75.75.75s.75-.34.75-.75V8.75h2.95c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
            }
          )
        ]
      }
    )
  }
));
i.displayName = "AgencyCircleAddIcon";
export {
  i as AgencyCircleAddIcon,
  i as default
};
//# sourceMappingURL=index.js.map
